import { instruments } from "@/constants/instruments";
import {
  Artist,
  Instrument,
  MixedModelConstructedNoDates,
  ModelNoDates,
} from "@/types/types";

export const isInstrumentTypeGuard = (
  instrumentMaybe:
    | Artist
    | Instrument
    | ModelNoDates
    | MixedModelConstructedNoDates
): instrumentMaybe is Instrument => {
  const instrumentIds = instruments.map((instrument) => instrument.id);

  return instrumentIds.includes(instrumentMaybe.id);
};
